import React from 'react';
import { useCssHandles } from '../../utils/functions';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectMenuState, setIsOpenMenu } from '../../redux/megaMenuSlice';
import Icon from '../icons/Icon';

const CSS_HANDLES = ['triggerContainer', 'triggerButtonIcon'];
const TriggerButton = (props) => {
	const dispatch = useDispatch();
	const { blockClass, componentId, Drawer, isActive, activeClassName, mutedClassName, ...rest } = props;
	const { handles } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass);
	const { handles: handles2 } = useCssHandles(`vtex-mega-menu-2-x`, CSS_HANDLES, blockClass, 'active');
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	const isOpenMenu = useSelector(selectMenuState);
	const isMobile = selectedCanvasResolution <= 1024 ? true : false;
	const orientationMenu = isMobile ? 'vertical' : 'horizontal';

	React.useEffect(() => {
		if (isOpenMenu) {
			dispatch(setIsOpenMenu(false));
		}
	}, []);

	return orientationMenu === 'vertical' || isMobile ? (
		// eslint-disable-next-line jsx-a11y/interactive-supports-focus
		<div
			role="button"
			onClick={() => {
				if (!isOpenMenu && orientationMenu === 'vertical') {
					dispatch(setIsOpenMenu(true));
				}

				if (!isOpenMenu && isMobile) {
					dispatch(setIsOpenMenu(true));
				}
			}}
		>
			{/* <Drawer /> */}
		</div>
	) : (
		<button
			data-selection={componentId}
			onClick={() => {
				console.log(4);
				dispatch(setIsOpenMenu(!isOpenMenu));
			}}
			className={`${handles.triggerContainer} pointer`}
		>
			<Icon
				id={'icon-menu-btn'}
				handle={handles.triggerButtonIcon}
				activeClassName={activeClassName}
				mutedClassName={mutedClassName}
				isActive={true}
				{...rest}
			/>
		</button>
	);
};

export default TriggerButton;
